import { useFormContext } from 'react-hook-form'
import { LightTooltip } from '.'
import { useEffect, useState } from "react";
import { p2e } from "../methods/CommonMethods";

export const Input = ({
    lable_text,
    hasError,
    type,
    name,
    placeholder,
    validation,
    tooltip_title,
    disable,
    value,
    direction,
    formContext,
    readOnly,
    isWidth100
}) => {

    const { register, formState: { errors }, setValue } = useFormContext()
    const [firstTime, setFirstTime] = useState(true)

    const inputError = findInputError(errors, name)
    const isInvalid = isFormInvalid(inputError)
    const inputRegister = register(name, validation);


    return (
        <div className='row justify-content-center my-4 testing'>
            <div className={`col-12 ${isWidth100 ? "" : "col-md-5"}`}>

                <label className="form-label text-form-title"
                >{lable_text}</label>
                {(validation && lable_text != "") ? <span className='required-label'>
                    *
                </span> : ''}

                {tooltip_title && <LightTooltip tooltip_title={tooltip_title} />}

                <input
                    disabled={!!disable}
                    readOnly={!!readOnly}
                    type={type}
                    name={name}
                    className={`form-control text-form-input py-2 
                        ${direction === "ltr" ? "text-start" : null} 
                        ${isInvalid ? "form-control-error" : null}
                        ${firstTime && hasError == 'error' ? "form-control-error" : null}
                        ${firstTime && hasError == 'correct' ? "form-control-correct" : null}
                        ${readOnly ? 'bg-disable' : ''}`
                    }

                    placeholder={placeholder}
                    {...(disable ? {} : inputRegister)}
                    onChange={(e) => {
                        if (!disable) {
                            inputRegister.onChange(e)
                            setFirstTime(false)
                            const convertedValue = p2e(e.target.value);
                            setValue(name, convertedValue, {
                                shouldValidate: true,
                                shouldDirty: true,
                            });
                        }
                    }}
                />

                {isInvalid && <InputError
                    show={isInvalid}
                    message={inputError?.error?.message}
                    key={inputError?.error?.message}
                />}
            </div>
        </div>
    )
}

export const InputError = ({ message, show }) => {
    return (
        <div className='text-danger mt-1' style={{ visibility: show ? "visible" : "hidden" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                    d="M6.08697 0.0234375C6.65993 0.0234375 7.17278 0.320587 7.45701 0.81827L11.4935 7.8757C11.7761 8.36946 11.7744 8.9587 11.4885 9.45133C11.2025 9.94451 10.6919 10.2389 10.1229 10.2389H2.04372C1.47414 10.2389 0.963536 9.94451 0.677622 9.45133C0.391707 8.9587 0.390022 8.36946 0.672566 7.8757L4.71694 0.817146C5.00117 0.320025 5.51346 0.0234375 6.08697 0.0234375ZM6.08641 0.866016C5.81903 0.866016 5.58086 1.0042 5.44718 1.23619L1.40392 8.29418C1.27248 8.52449 1.27361 8.79917 1.40673 9.02891C1.53986 9.25866 1.77803 9.39628 2.04372 9.39628H10.1229C10.3881 9.39628 10.6262 9.25866 10.7593 9.02891C10.893 8.79917 10.8942 8.52449 10.7616 8.29418L6.72565 1.23619C6.59252 1.0042 6.35435 0.866016 6.08641 0.866016ZM6.08259 7.04436C6.39322 7.04436 6.64431 7.29545 6.64431 7.60608C6.64431 7.91671 6.39322 8.1678 6.08259 8.1678C5.77196 8.1678 5.51806 7.91671 5.51806 7.60608C5.51806 7.29545 5.76691 7.04436 6.07697 7.04436H6.08259ZM6.08147 3.71056C6.31402 3.71056 6.50276 3.8993 6.50276 4.13185V5.87318C6.50276 6.10573 6.31402 6.29447 6.08147 6.29447C5.84892 6.29447 5.66018 6.10573 5.66018 5.87318V4.13185C5.66018 3.8993 5.84892 3.71056 6.08147 3.71056Z"
                    fill="#FF2B2B" />
            </svg>
            <span className='text-form-input-error'>{message ?? ""}</span>

        </div>
    )
}

export function findInputError(errors, name) {
    const filtered = Object.keys(errors)
        .filter(key => key.includes(name))
        .reduce((cur, key) => {
            return Object.assign(cur, { error: errors[key] })
        }, {})
    return filtered
}

export const isFormInvalid = err => {
    if (Object.keys(err).length > 0) return true
    return false
}